import React, { useState } from 'react';
import { IconHide, IconShow, TextField, TextFieldButton } from 'src/viewLayer/components/DesignSystem';
import { t } from 'src/viewLayer/helpers/translations';

export default ({
  value,
  onChangeHandler,
  errorKey,
  isFocused,
  disabled,
  placeholder,
  label,
  id
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <TextField
      color="lightened"
      actionButton={
        value ?
          <TextFieldButton
            onClick={() => setVisible((previous) => !previous)}
            icon={ visible ? <IconShow /> : <IconHide /> }
            title={ visible ? 'Hide' : 'Show' }
          />
        : null
      }
      ariaDescribedby={id ? `message-${id}` : "message-uat-password-input-field"}
      autoComplete="new-password"
      autoFocus={ isFocused }
      additionalText={ errorKey && t(errorKey) }
      disabled={ disabled }
      fullWidth
      id={id || "uat-password-input-field"}
      label={label}
      onChange={ onChangeHandler }
      placeholder={ placeholder || t('password.placeholder') }
      state={ errorKey ? 'error' : 'default' }
      type={ visible ? 'text' : 'password' }
      value={ value }
    />
  );
};
